import { Sentry } from '@/lib/logs';

import { setAnalyticsConsent } from './hooks/PostHogAnalytics';

const handleCookieConsent = () => {
  if (window.Cookiebot?.consent.statistics) {
    setAnalyticsConsent(true);
    Sentry.init();
  }

  if (window.Cookiebot?.consent.marketing) {
    const hubSpotScript = document.createElement('script');
    hubSpotScript.type = 'text/javascript';
    hubSpotScript.id = 'hs-script-loader';
    hubSpotScript.async = true;
    hubSpotScript.defer = true;
    hubSpotScript.src = 'https://js-eu1.hs-scripts.com/25771685.js';

    document.body.appendChild(hubSpotScript);
  }
};

// for users who already accepted cookies, we check against stored cookies
// prevents the need to sign out, clear cookies, sign in again
window.addEventListener('CookiebotOnLoad', handleCookieConsent, false);

window.addEventListener('CookiebotOnAccept', handleCookieConsent, false);
